import { render } from "./AssignTemplateModal.vue?vue&type=template&id=02953cdf&scoped=true"
import script from "./AssignTemplateModal.vue?vue&type=script&lang=js"
export * from "./AssignTemplateModal.vue?vue&type=script&lang=js"

import "./AssignTemplateModal.vue?vue&type=style&index=0&id=02953cdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02953cdf"]])

export default __exports__